import { prepareExternalUrl } from '@/core/url/url.service';
import { BotProvisionConfirm } from '@/pages/botProvision';
import { Download } from '@/pages/download/Download';
import { MyApps } from '@/pages/myApps';
import { Page } from '@/pages/page';
import { ProfilePreviewPage } from '@/pages/profile/preview';
import ProfileNotAvailableForPartner from '@/pages/profile/profileNotAvailableForPartner/ProfileNotAvailableForPartner';
import { SearchPage } from '@/pages/search';
import { getCompatibilitySearchPath } from '@/routes/getCompatibilityPaths';
import { IRoute } from '@/routes/route.interface';
import { withQueryParamCleaner } from '@/shared';
import { rootStore } from '@/stores';

enum RouteSettingsProperty {
  homePage = 'homePage',
  searchPage = 'searchPage',
  profilePreviewPage = 'profilePreviewPage',
  appInstallPage = 'appInstallPage',
  myAppsPage = 'myAppsPage',
  profileNotAvailableForPartner = 'profileNotAvailableForPartner',
  download = 'download',
}

const MyAppsWithQueryParamCleaner = withQueryParamCleaner(MyApps, []);

export const getRouteSettings = (): Record<RouteSettingsProperty, IRoute> => ({
  homePage: {
    path: '/',
    exact: true,
    component: Page,
    data: {
      isLandingPage: true,
    },
  },
  searchPage: {
    path: rootStore.compatibilitiesStore.items.map((compatibility) =>
      getCompatibilitySearchPath(compatibility.slug),
    ),
    exact: true,
    component: SearchPage,
    data: {
      isSearchPage: true,
    },
  },
  profilePreviewPage: {
    path: '/preview/:profileId',
    component: ProfilePreviewPage,
  },
  appInstallPage: {
    path: '/:appId/install',
    component: BotProvisionConfirm,
    data: {
      auth: true,
    },
  },
  myAppsPage: {
    path: '/my-apps',
    component: MyAppsWithQueryParamCleaner,
    data: {
      auth: true,
      redirect: prepareExternalUrl('/'),
    },
  },
  profileNotAvailableForPartner: {
    path: '/not-available',
    exact: true,
    component: ProfileNotAvailableForPartner,
  },
  download: {
    path: '/download',
    component: Download,
    exact: true,
  },
});
